export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    console.log(this.classes)
    this.content = content
  }

  build() {
    return `<div class="${this.classes.classes}">
      <wfs-carousel
          id="${this.ids.id}"
          ${this.content.hasButtons ? 'hasButtons': ''}
          ${this.content.hasDots ? 'hasDots': ''}
          ${this.content.hasInterval ? 'interval="'+this.content.interval+'"': ''}
      >
          ${this.slidesSlot()}
          ${this.buttonsSlot()}
          ${this.dotsSlot()}
      </wfs-carousel>
    </div>`
  }

  slidesSlot() {
    return `<template v-slot:slides>
        ${this.content.sections.map(section => section.html).join('')}
    </template>`
  }

  buttonsSlot() {
    return `<template v-slot:previous-button="{showPreviousSlide}">
        <button
          class="carousel-buttons wf-w-8 wf-h-8 wf-absolute focus:wf-outline-none wf-my-auto wf-ml-2 wf-inset-y-0 wf-left-0 wf-ml-2 ${this.classes.buttonsClasses}"
          @click.prevent="showPreviousSlide()"
        ><i class="fas fa-chevron-left"></i></button>
    </template>

    <template v-slot:next-button="{showNextSlide}">
        <button
          class="carousel-buttons wf-w-8 wf-h-8 focus:wf-outline-none wf-my-auto wf-inset-y-0 wf-absolute wf-right-0 wf-mr-2 ${this.classes.buttonsClasses}"
          @click.prevent="showNextSlide()"
        ><i class="fas fa-chevron-right"></i></button>
    </template>`
  }

  dotsSlot() {
    return `<template v-slot:position-dots="{slidesIndexes, activeSlide, setActiveSlide}">
      <ul class="wf-flex wf-absolute wf-w-full wf-bottom-0 wf-mb-2 wf-mx-auto wf-inset-x-0 wf-items-center wf-justify-center">
        <li v-for="index in slidesIndexes" :key="index">
          <button
            @click.prevent="setActiveSlide(index)"
            class="carousel-dots wf-mx-2 ${this.classes.dotsClasses}"
            :class="activeSlide === index ? ['carousel-dots--active'] : ['']"
          ></button>
        </li>
      </ul>
    </template>`
  }


}